import React from "react";

type Size = "xs" | "sm" | "md" | "lg";

type LoadingSpinnerProps = {
  size?: Size;
  className?: string;
  color?: "primary" | "white" | "current";
};

const sizeClasses: Record<Size, string> = {
  xs: "w-3 h-3 border",
  sm: "w-4 h-4 border-2",
  md: "w-6 h-6 border-2",
  lg: "w-8 h-8 border-2",
};

const colorClasses: Record<string, string> = {
  primary: "border-primary border-t-transparent",
  white: "border-white border-t-transparent",
  current: "border-current border-t-transparent",
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "sm",
  className = "",
  color = "primary",
}) => {
  const sizeClass = sizeClasses[size];
  const colorClass = colorClasses[color];

  return (
    <div
      className={`${sizeClass} ${colorClass} rounded-full animate-spin ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
};

export default LoadingSpinner;



